





















import {
    Component,
    Vue,
    Prop,
    Watch
} from "vue-property-decorator";
import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    pageDataType,
    CampaignPageDataType
} from "../types";
import {
    HOST,
    API_URL
} from "../global";
import {
    FETCH_CAMPAIGN_DATA
} from "../store/actions.names";
import {
    SET_CAMPAIGN_CURRENT_PAGE,
    SET_CAMPAIGN_DATA,
    CURRENT_PAGE_ERROR,
    SET_CAMPAIGN_PARENT_PAGE
} from "../store/mutations.names";
import axios from "axios";
import BannerTextBlock from "../components/BannerTextBlock.vue";
import CampaignImgText from "../components/CampaignImgText.vue";
import VideoCard from "../components/VideoCard.vue";
import Smfullimgblock from '../components/Smfullimgblock.vue';
@Component({
    name: 'CampaignDetailPage',
    components: {
        banner: BannerTextBlock,
        campgin_detail_richtext: CampaignImgText,
        youtube_video_block: VideoCard,
        single_image: Smfullimgblock

    },
})
export default class CampaignDetailPage extends Vue {
    @Getter("campaignData") public campaignData!: CampaignPageDataType[];
    @Prop() public pageData!: pageDataType;
    @Getter("pageType") public pageType!: string | null;
    @Action(FETCH_CAMPAIGN_DATA) public fetchData: any;
    @Mutation(SET_CAMPAIGN_CURRENT_PAGE) public[SET_CAMPAIGN_CURRENT_PAGE]: any;
    public HOST: string = HOST;
    public mounted() {
        this.fetchData(this.pageData.id);
    }
}
